import moment from "moment";
import { SignOut, IsLogged, GetAuthorizationHeader } from "@TaankYou/auth";
import { OpenFC } from "./utils/freshchat";

let WebStorage = require('react-webstorage');
let observer = require("node-observer");


export class Utils {
    static _autoCompleteService = null;

    static goTo(component=null, href="/", replace=false){
        let history = Registry.registred("history");
        if(replace)
            history.replace({pathname: href});
        else
            history.push({pathname: href});
    }

    static formatDate(date_str, format="dddd DD MMMM HH:mm"){
        return Utils.formatUtcDate(date_str, format);
    }

    static formatUtcDate(date_str, format="dddd DD MMMM HH:mm"){
        let date = new Date(date_str);
        return moment(date).format(format);
    }

    static goToNewTab(url){
        let win = window.open(url, "_blank");
        if (win)
            win.focus();
    }

    static str_to_key(str) {
        str = str.toLowerCase();
        str = str.replace(/\s+/g, "-");
        return str;
    }

    static openIntercom(message=""){
        OpenFC(message);
    }

    static displayWeights(value){
        let w = parseFloat(value);
        let it = 0;
        let units = ["g", "kg", "T"];
        while(w > 1000 && it < 2){
            w = w / 1000;
            it++;
        }
        if(it > 2)
            it = 2;

        return w.toFixed(2).toString() + " " + units[it]
    }

    static isMobile(){
        let check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
    }

    static scrollMobile(x,y) {
        let mobile = Utils.isMobile();
        if (mobile)
            window.scrollTo(x,y);
    }

    static scrollSignUp(refs) {
        refs.scrollIntoView({block: 'end', behavior: 'smooth'});
    }

    static getGeoSuggest(value, callback, country = "fr") {
        if (value === null || value === "") {
            return;
        }
        let googleMaps = (window.google && // eslint-disable-line no-extra-parens
            window.google.maps) ||
            this.googleMaps;

        if(!Utils._autoCompleteService)
            Utils._autoCompleteService = new googleMaps.places.AutocompleteService();

        let options = {
            input: value,
        };

        options.componentRestrictions = {
            country: country
        };
        let locations = [];
        Utils._autoCompleteService.getPlacePredictions(options, (suggestsGoogle) => {
            if (suggestsGoogle !== null) {
                for (let i = 0; i < suggestsGoogle.length; i++) {
                    locations[i] = suggestsGoogle[i].structured_formatting;
                }
            }
            callback(locations);
        });

        return;
    }

    static getPositionX(valueMarker, min, max, centerMarker, sliderWidth) {
        return ((valueMarker - min) * sliderWidth) / (max - min) - centerMarker;
    }

    static getValueMarker(positionX, min, max, centerMarker, sliderWidth) {
        return min + (((positionX + centerMarker) * (max - min)) / sliderWidth);
    }
}

/**
 * Class used to handle API calls
 */
export class Api{
    url        = null;
    headers    = null;
    webStorage = null;

    constructor(url){
        this.url = url;
        this.headers = {
            "X-Language": (window.navigator.userLanguage || window.navigator.language).split("-")[0],
            "X-Application-Id": "website"
        };
        this.webStorage = new WebStorage(window.localStorage || window.sessionStorage);
        this.cookies = false;
    }

    /**
     * Will add headers to instance
     *
     * @param {*} data
     */
    addHeaders(data = {}){
        for(let h in data){
            if (data.hasOwnProperty(h))
                this.headers[h] = data[h];
        }
    }

    /**
     * Will replace instance's headers
     * @param {*} data
     */
    setHeaders(data = null){
        this.headers = data;
    }
    
    getUser(){
        if (IsLogged()) {
            return this.get("/customers", { handleUnauth: false })
                .then(res => res)
                .catch(() => false);
        }

        return Promise.reject(false);
    }

    /**
     *
     * @param {string} method POST, GET, PUT, DELETE
     * @param {string} endpoint
     * @param {*} data POST data if needed empty for no body
     */
    _fetch(method, endpoint, data=null, opt={}){
        // Base header construction
        let _headers = new Headers(this.headers);

		/**
		 * Retrieving csrf headers
		 */
		let csrf_token = this.webStorage.getItem("csrf_token");

		if(csrf_token)
			_headers.set("X-Csrf-Token", csrf_token);

        // Request options, method, headers and body if needed
        let options = {
            method: method,
            headers: _headers
        };

        let response_type = 'json';
        if(opt.response_type)
            response_type = opt.response_type;

        if(this.cookies)
            options['credentials'] = "include";

        
        if(IsLogged())
            options.headers.append("Authorization", GetAuthorizationHeader());

        /*
         * Creating body if needed
         */
        if(data !== null){
           let formData = new FormData();
            Object.keys(data).forEach(key => formData.append(key, data[key]));
            options.body = formData;
        }

        /**
         * Main call
         */
        return fetch(this.url + endpoint, options)
            .then(res => {
                if(response_type === 'json'){
                    if(!res.ok || (res.status !== 200 && res.status !== 201))
                        return res.json().then(e => {throw e;});
                    return res.json();
                }
                else if(response_type === 'blob')
                    return res.blob();
            })
            .then( res => { return Promise.resolve(res); })
            .catch(e => {
                if(e.subcode && e.subcode === "AuthUnauthorized") {
                    if (!this.webStorage.getItem("last-location"))
                        this.webStorage.setItem("last-location", window.location.pathname);
                    const { protocol, host } = window.location;
                    SignOut(`${protocol}//${host}`);
                }
                throw e;
            });
    }

    get(endpoint){
        return this._fetch("GET", endpoint);
    }

    del(endpoint, data){
        return this._fetch("DELETE", endpoint, data);
    }

    post(endpoint, data){
        return this._fetch("POST", endpoint, data);
    }

    put(endpoint, data){
        return this._fetch("PUT", endpoint, data);
    }

    download(endpoint, filename){
        return this._fetch("GET", endpoint, null, {
            response_type: 'blob'
        })
            .then(blob => {
                let url = window.URL.createObjectURL(blob);
                let a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();                    
            })
            .catch(e => {
                throw e;
            });
    }
}

/**
 * Class used to create a registry dict
 */
export class Registry{
    static _objects = {};

    /**
     * Use to register an object to registry
     *
     * @param {string} key
     * @param {*} object
     */
    static register(key, object){
        Registry._objects[key] = object;
        observer.send(this, "registred", {
            key: key,
            data: object
        });
    }

    /**
     * Use to retrieve a registred object
     * If object not found, null is returned
     *
     * @param {string} key
     */
    static registred(key){
        if(Registry._objects.hasOwnProperty(key))
            return Registry._objects[key];
        return null;
    }

    static observe(cls, key, callback = function(data){}){
        observer.subscribe(cls, "registred", (cls, data) => {
            if(data.key === key)
                callback(data.data);
        });

        return Registry.registred(key);
    }

    static remove(key){
        Registry.register(key, null);
    }
}

export class AppLink{
    static isMobile(){
        return (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i) || navigator.userAgent.match(/(android|Android);?/i));
    }

    static openFallback(ts, delay, storeLink){
        return () => {
            let wait = delay + 500;
            if (typeof storeLink === "string" && (Date.now() - ts) < wait)
                window.location.href = storeLink;
        };
    }

    static launchiOS(options) {
        if (!!options.iframe)
            return AppLink._launchiFrame(options)
        let wait = options.wait || 500;
        if(options.fallback)
            setTimeout(options.fallback, wait);
        else if(options.storeLink)
            setTimeout(AppLink.openFallback(Date.now(), wait, options.storeLink), wait);
        window.location = options.urlScheme;
    }

    static launchAndroid(options) {
        let wait = options.wait || 500;
        if (navigator.userAgent.match(/Chrome/)) {
            if(options.fallback)
                setTimeout(options.fallback, wait);
            else if(options.chromeUrlScheme)
                setTimeout(AppLink.openFallback(Date.now(), wait, options.chromeUrlScheme), wait);
            window.location = options.urlScheme;
            return;
        } else if(navigator.userAgent.match(/Firefox/)) {
            if(options.fallback)
                setTimeout(options.fallback, wait);
            else if(options.storeLink)
                setTimeout(AppLink.openFallback(Date.now(), wait, options.storeLink), wait);
            window.location = options.urlScheme;
        } else
            AppLink._launchiFrame(options);
    }

    static _launchiFrame = function (options) {
        let iframe = document.createElement("iframe");
        iframe.src = options.urlScheme;
        iframe.style.border = "none";
        iframe.style.display = 'none';
        iframe.style.width = "1px";
        iframe.style.height = "1px";
        iframe.onload = () => {
            if (!!options.storeLink)
                window.location = options.storeLink;
        };
        document.body.appendChild(iframe);
    };

    static goAppLink(action, arg, options={}){
        if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i) ||
            navigator.userAgent.match(/(android|Android);?/i)) {

            if(action){
                let app_link = action + (arg ? "/" + arg : "");

                if(navigator.userAgent.match(/(android|Android);?/i))
                    window.location = "intent://tankyou/"+app_link+"#Intent;scheme=http;package=co.tankyou.app;end";
                else{
                    AppLink.launchiOS({
                        urlScheme: "tankyou://" + app_link,
                        ...options
                    });
                }

                return true;
            }
        }

        return false;
    }
}

export default Utils;
